import type { CommandPaletteSearchFEResult } from '../../../../shared/CommandPalette/types';

import { ALL_ROUTES } from './navigation';

const allRoutes = Array.from(ALL_ROUTES.values());

/**
 * Returns all navigable routes.
 */
export function useNavigableRoutes(): CommandPaletteSearchFEResult[] {
  //  Filter out routes that should not be navigable.
  //  Note that this isn't memoized, because we want to re-evaluate the shouldEnable function on every render.
  return allRoutes.filter((route) => route.shouldEnable());
}

export default useNavigableRoutes;
